import template from './opportunitiesPanel.html';
import controller from './opportunitiesPanel.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    opportunities: '<',
    title: '@',
    collapsed: '<',
    onToggleCollapsed: '&',
  }
};

export default component;
